import type { InjectionKey } from 'vue'
import type { UserProfile, UserCredits, SubscriptionDetails } from '../entities/UserProfile'
import type { MemberProfileDetails, UpdateMemberProfilePayload } from '../entities/MemberProfile'

export interface IUserProfileService {
  getUserProfile(): Promise<UserProfile>
  getCredits(): Promise<UserCredits>
  getSubscriptionDetails(): Promise<SubscriptionDetails>
  getMemberProfileDetails(): Promise<MemberProfileDetails>
  updateMemberProfile(payload: UpdateMemberProfilePayload): Promise<void>
}

export const USER_PROFILE_SERVICE_KEY: InjectionKey<IUserProfileService> = Symbol('UserProfileService')
